import api from "../services/api";
import { ISeason, ISeasonDetail, CreateSeasonDTO, EditSeasonDTO, ITournamentType } from "../models/ISeason";

export const getAllSeasons = (): Promise<{ data: ISeason[] }> => api.get("season");

export const getSeasonById = (id: string): Promise<{ data: ISeason }> => api.get(`season/${id}`);

export const getSeasonDetail = (id: string): Promise<{ data: ISeasonDetail }> => api.get(`season/${id}/detail`);

export const getSeasonsByType = (typeId: string): Promise<{ data: ISeason[] }> => api.get(`season/type/${typeId}`);

export const getActiveSeasons = (): Promise<{ data: ISeason[] }> => api.get("season/active");

export const createSeason = (season: CreateSeasonDTO): Promise<{ data: ISeason }> => api.post("season", season);

export const updateSeason = (id: string, season: EditSeasonDTO): Promise<{ data: ISeason }> =>
  api.put(`season/${id}`, season);

export const deleteSeason = (id: string): Promise<{ data: boolean }> => api.delete(`season/${id}`);

export const getTournamentTypes = (): Promise<{ data: ITournamentType[] }> => api.get("Tournament/types");

